module.exports = __webpack_public_path__ + "static/media/ico_estrias.be44fcb6.svg";